// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_entry-component-container__MTPQV{
    width: 100vw;
    height: 60vw;
    margin-top: -5vw;
    display: flex;
}

.Home_entry-component-image__EJYxz{
    width: 100vw;
    height: 60vw;
    position: absolute;
}

.Home_entry-component-title__EfuAm{
    position: absolute;
    width: 100%;
    text-align: center;
}

.Home_entry-component-title-heading__ADges{
    font-size: 5vw;
    margin: 0px;
    font-family: dm-sans-medium;
}

.Home_entry-component-title-description__D4uIF{
    font-size: 1.5vw;
    margin: 0.8vw;
    font-family: dm-sans-medium;
}

.Home_entry-component-search-box-container__GBxBT{
    position: absolute;
    margin-top: 26vw;
    width: 61vw;
    height: 7vw;
    background-color: rgba(255, 255, 255, 0.37);
    margin-left: 19.5vw;
    border-radius: 100vw;
    font-family: dm-sans-regular;
}

.Home_trip-filter__QgLb3{
    width: 83vw;
    height: 5vw;
    margin-left: auto;
    margin-right: auto;
    border-radius: 100vw;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    flex-direction: row;
    margin-top: 1.5vw;
}

.Home_upcoming-explorations__\\+7VZB{
    font-size: 3vw;
    text-align: center;
    margin-bottom: 0px;
    font-family: dm-sans-medium;
}

.Home_upcoming-explorations-subline__0cHvv{
    text-align: center;
    font-size: 1.2vw;
}

.Home_upcoming-text-m__ehnuZ{
    display: none;
}

.Home_underline__Py5XA{
    color: rgb(230, 84, 57);
    font-size: 3vw;
    text-align: center;
    margin-top: -2.5vw;
    margin-bottom: 0px;
    font-family: sans-serif;
}

.Home_filter-display-handler-1__P6J15{
    display: none;
}

.Home_view-all-button__Y0kd1{
    width: 15vw;
    height: 3.5vw;
    border-radius: 100vw;
    border: 1px solid black;
    background-color: transparent;
    margin-top: 2vw;
    margin-bottom: 1vw;
    align-self: center;
    margin-left: 42.5vw;
    font-size: 1.6vw;
    font-family: dm-sans-regular;
}

.Home_view-all-button__Y0kd1:hover{
    background-color: #e65439;
    color: white;
    border: none;
    cursor: pointer;
    transform: scale(1.1);
    transition: 0.3s ease-in-out;
}

.Home_book-exploration__kC3Lf{
    font-size: 3vw;
    text-align: center;
    margin-bottom: 0px;
    font-family: dm-sans-medium;
}

.Home_break__OnrHF{
    display: none;
}

.Home_svg-container__7\\+ZSq{
    width: 100%;
    height: 15vw;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 3vw;

}

.Home_svg__JkjvG{
    width: 30vw;
    display: flex;
    flex-direction: column;
}

.Home_svg-text__-xCJ\\+{
    font-size: 1.6vw;
    margin-top: 0;
    text-align: center;
    font-family: dm-sans-light;
}

.Home_svg-subtext__Q2L3K{
    font-size: 1vw;
    width: 80%;
    align-self: center;
    text-align: center;
    margin-top: 0.5vw;
    height: 8vw;
    
}

.Home_amazing-influencers__DaOE5{
    font-size: 3vw;
    text-align: center;
    margin-bottom: 0px;
    font-family: dm-sans-medium;
}

.Home_text-happy-explorers__fu9vJ{
    font-size: 3vw;
    text-align: center;
    margin-bottom: 0;
    font-family: dm-sans-medium;
}

.Home_empty-1__uYFyZ{
    width: 100%;
    height: 4vw;
}

.Home_travel-influencer-container__qlevp{
    width: 70vw;
    height: auto;
    margin: auto;
    border-radius: 2vw;
    overflow: hidden;
    margin-bottom: 10vw;
    display: flex;
}

.Home_travel-inf-img__8rnt5{
    width: 100vw;
    object-fit: contain;
    border-radius: 2vw;
}

.Home_travel-inf-text-1__\\+RIFU{
    margin-left: 2vw;
    margin-top: 6vw;
    font-size: 2vw;
    font-weight: bold;
    position: absolute;
    font-family: dm-sans-light;
}

.Home_travel-inf-text-2__N5SB1{
    margin-left: 2vw;
    margin-top: 9vw;
    font-size: 1.2vw;
    font-weight: bold;
    position: absolute;
    font-family: dm-sans-light;
}

.Home_travel-inf-btn__XcHYZ{
    position: absolute;
    margin-left: 2vw;
    margin-top: 15vw;
    width: 10vw;
    height: 3vw;
    border-radius: 100vw;
    background-color: #e65439;
    color: white;
    border: none;
    font-size: 1.2vw;
    font-family: dm-sans-light;
}


@media(max-width: 768px){
    .Home_entry-component-container__MTPQV{
        width: 100vw;
        height: 150vw;
        margin-top: -13vw;
        display: flex;
    }

    .Home_entry-component-title__EfuAm{
        position: absolute;
        margin-top: 12vw;
        width: 100%;
        text-align: center;
    }

    .Home_entry-component-title-heading__ADges{
        font-size: 6vw;
        margin: 0px;
        margin-top: 12vw;
    }

    .Home_entry-component-title-description__D4uIF{
        width: 86vw;
        text-align: center;
        font-size: 3vw;
        margin-left: 7vw;
        margin-top: 2vw;
    }

    .Home_upcoming-explorations__\\+7VZB{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 0px;
    }

    .Home_upcoming-text-w__6Q5i3{
        display: none;
    }

    .Home_upcoming-text-m__ehnuZ{
        display: block;
    }

    .Home_upcoming-explorations-subline__0cHvv{
        display: none;
    }

    .Home_underline__Py5XA{
        color: rgb(230, 84, 57);
        font-size: 5vw;
        text-align: center;
        margin-top: -3vw;
        margin-bottom: 0px;
        font-family: serif;
    }

    .Home_filter-display-handler__DBLBy{
        display: none;
    }

    .Home_filter-display-handler-1__P6J15{
        display: flex;
        margin: auto;
        height: 13vw;
        margin-top: 7vw;
        margin-bottom: 7vw;
    }

    .Home_trip-filter__QgLb3{
        display: none;
    }

    .Home_view-all-button__Y0kd1{
        width: 40vw;
        height: 10vw;
        border-radius: 100vw;
        border: 1px solid black;
        background-color: transparent;
        /* margin-bottom: 1vw; */
        align-self: center;
        margin-left: 30vw;
        margin-top: 10vw;
        font-size: 4vw;
        margin-bottom: 5vw;
    }

    .Home_book-exploration__kC3Lf{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 0px;
    }

    .Home_break__OnrHF{
        display: inline;
    }


    .Home_svg-container__7\\+ZSq{
        width: 100%;
        height: auto;
        display: none;
        /* display: flex; */
        flex-direction: column;
        align-items: center;
        margin-top: 2vh;
        margin-bottom: 0vh;
    }
    
    .Home_svg__JkjvG{
        width: 60vw;
        display: flex;
        flex-direction: column;
    }
    
    .Home_svg-text__-xCJ\\+{
        font-size: 4vw;
        margin-top: 1vh;
        text-align: center;
        margin-bottom: 4vh;
    }

    .Home_amazing-influencers__DaOE5{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 0px;
    }

    .Home_text-happy-explorers__fu9vJ{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 0;
        margin-top: 10vw;
    }
    
    .Home_empty-1__uYFyZ{
        width: 100%;
        height: 4vw;
    }


    .Home_travel-influencer-container__qlevp{
        width: 95vw;
        height: auto;
        margin: auto;
        border-radius: 2vw;
        overflow: hidden;
        margin-bottom: 10vw;
        margin-top: 8vw;
        display: flex;
    }

    .Home_travel-inf-img__8rnt5{
        width: 100vw;
        object-fit: contain;
        border-radius: 2vw;
    }

    .Home_travel-inf-text-1__\\+RIFU{
        margin-left: 3vw;
        margin-top: 6vw;
        font-size: 4vw;
        font-weight: bold;
        position: absolute;
    }

    .Home_travel-inf-text-2__N5SB1{
        margin-left: 3vw;
        margin-top: 11vw;
        font-size: 2.8vw;
        font-weight: normal;
        position: absolute;
    }

    .Home_travel-inf-btn__XcHYZ{
        position: absolute;
        margin-left: 3vw;
        margin-top: 20vw;
        width: 20vw;
        height: 6vw;
        border-radius: 1vw;
        background-color: #e65439;
        color: white;
        border: none;
        font-size: 2.3vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Home.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;;AAEnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;;AAEf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;AAC9B;;;AAGA;IACI;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,uBAAuB;QACvB,6BAA6B;QAC7B,wBAAwB;QACxB,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;;IAGA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;AACJ","sourcesContent":[".entry-component-container{\n    width: 100vw;\n    height: 60vw;\n    margin-top: -5vw;\n    display: flex;\n}\n\n.entry-component-image{\n    width: 100vw;\n    height: 60vw;\n    position: absolute;\n}\n\n.entry-component-title{\n    position: absolute;\n    width: 100%;\n    text-align: center;\n}\n\n.entry-component-title-heading{\n    font-size: 5vw;\n    margin: 0px;\n    font-family: dm-sans-medium;\n}\n\n.entry-component-title-description{\n    font-size: 1.5vw;\n    margin: 0.8vw;\n    font-family: dm-sans-medium;\n}\n\n.entry-component-search-box-container{\n    position: absolute;\n    margin-top: 26vw;\n    width: 61vw;\n    height: 7vw;\n    background-color: rgba(255, 255, 255, 0.37);\n    margin-left: 19.5vw;\n    border-radius: 100vw;\n    font-family: dm-sans-regular;\n}\n\n.trip-filter{\n    width: 83vw;\n    height: 5vw;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 100vw;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);\n    display: flex;\n    flex-direction: row;\n    margin-top: 1.5vw;\n}\n\n.upcoming-explorations{\n    font-size: 3vw;\n    text-align: center;\n    margin-bottom: 0px;\n    font-family: dm-sans-medium;\n}\n\n.upcoming-explorations-subline{\n    text-align: center;\n    font-size: 1.2vw;\n}\n\n.upcoming-text-m{\n    display: none;\n}\n\n.underline{\n    color: rgb(230, 84, 57);\n    font-size: 3vw;\n    text-align: center;\n    margin-top: -2.5vw;\n    margin-bottom: 0px;\n    font-family: sans-serif;\n}\n\n.filter-display-handler-1{\n    display: none;\n}\n\n.view-all-button{\n    width: 15vw;\n    height: 3.5vw;\n    border-radius: 100vw;\n    border: 1px solid black;\n    background-color: transparent;\n    margin-top: 2vw;\n    margin-bottom: 1vw;\n    align-self: center;\n    margin-left: 42.5vw;\n    font-size: 1.6vw;\n    font-family: dm-sans-regular;\n}\n\n.view-all-button:hover{\n    background-color: #e65439;\n    color: white;\n    border: none;\n    cursor: pointer;\n    transform: scale(1.1);\n    transition: 0.3s ease-in-out;\n}\n\n.book-exploration{\n    font-size: 3vw;\n    text-align: center;\n    margin-bottom: 0px;\n    font-family: dm-sans-medium;\n}\n\n.break{\n    display: none;\n}\n\n.svg-container{\n    width: 100%;\n    height: 15vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    margin-top: 3vw;\n\n}\n\n.svg{\n    width: 30vw;\n    display: flex;\n    flex-direction: column;\n}\n\n.svg-text{\n    font-size: 1.6vw;\n    margin-top: 0;\n    text-align: center;\n    font-family: dm-sans-light;\n}\n\n.svg-subtext{\n    font-size: 1vw;\n    width: 80%;\n    align-self: center;\n    text-align: center;\n    margin-top: 0.5vw;\n    height: 8vw;\n    \n}\n\n.amazing-influencers{\n    font-size: 3vw;\n    text-align: center;\n    margin-bottom: 0px;\n    font-family: dm-sans-medium;\n}\n\n.text-happy-explorers{\n    font-size: 3vw;\n    text-align: center;\n    margin-bottom: 0;\n    font-family: dm-sans-medium;\n}\n\n.empty-1{\n    width: 100%;\n    height: 4vw;\n}\n\n.travel-influencer-container{\n    width: 70vw;\n    height: auto;\n    margin: auto;\n    border-radius: 2vw;\n    overflow: hidden;\n    margin-bottom: 10vw;\n    display: flex;\n}\n\n.travel-inf-img{\n    width: 100vw;\n    object-fit: contain;\n    border-radius: 2vw;\n}\n\n.travel-inf-text-1{\n    margin-left: 2vw;\n    margin-top: 6vw;\n    font-size: 2vw;\n    font-weight: bold;\n    position: absolute;\n    font-family: dm-sans-light;\n}\n\n.travel-inf-text-2{\n    margin-left: 2vw;\n    margin-top: 9vw;\n    font-size: 1.2vw;\n    font-weight: bold;\n    position: absolute;\n    font-family: dm-sans-light;\n}\n\n.travel-inf-btn{\n    position: absolute;\n    margin-left: 2vw;\n    margin-top: 15vw;\n    width: 10vw;\n    height: 3vw;\n    border-radius: 100vw;\n    background-color: #e65439;\n    color: white;\n    border: none;\n    font-size: 1.2vw;\n    font-family: dm-sans-light;\n}\n\n\n@media(max-width: 768px){\n    .entry-component-container{\n        width: 100vw;\n        height: 150vw;\n        margin-top: -13vw;\n        display: flex;\n    }\n\n    .entry-component-title{\n        position: absolute;\n        margin-top: 12vw;\n        width: 100%;\n        text-align: center;\n    }\n\n    .entry-component-title-heading{\n        font-size: 6vw;\n        margin: 0px;\n        margin-top: 12vw;\n    }\n\n    .entry-component-title-description{\n        width: 86vw;\n        text-align: center;\n        font-size: 3vw;\n        margin-left: 7vw;\n        margin-top: 2vw;\n    }\n\n    .upcoming-explorations{\n        font-size: 6vw;\n        text-align: center;\n        margin-bottom: 0px;\n    }\n\n    .upcoming-text-w{\n        display: none;\n    }\n\n    .upcoming-text-m{\n        display: block;\n    }\n\n    .upcoming-explorations-subline{\n        display: none;\n    }\n\n    .underline{\n        color: rgb(230, 84, 57);\n        font-size: 5vw;\n        text-align: center;\n        margin-top: -3vw;\n        margin-bottom: 0px;\n        font-family: serif;\n    }\n\n    .filter-display-handler{\n        display: none;\n    }\n\n    .filter-display-handler-1{\n        display: flex;\n        margin: auto;\n        height: 13vw;\n        margin-top: 7vw;\n        margin-bottom: 7vw;\n    }\n\n    .trip-filter{\n        display: none;\n    }\n\n    .view-all-button{\n        width: 40vw;\n        height: 10vw;\n        border-radius: 100vw;\n        border: 1px solid black;\n        background-color: transparent;\n        /* margin-bottom: 1vw; */\n        align-self: center;\n        margin-left: 30vw;\n        margin-top: 10vw;\n        font-size: 4vw;\n        margin-bottom: 5vw;\n    }\n\n    .book-exploration{\n        font-size: 6vw;\n        text-align: center;\n        margin-bottom: 0px;\n    }\n\n    .break{\n        display: inline;\n    }\n\n\n    .svg-container{\n        width: 100%;\n        height: auto;\n        display: none;\n        /* display: flex; */\n        flex-direction: column;\n        align-items: center;\n        margin-top: 2vh;\n        margin-bottom: 0vh;\n    }\n    \n    .svg{\n        width: 60vw;\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .svg-text{\n        font-size: 4vw;\n        margin-top: 1vh;\n        text-align: center;\n        margin-bottom: 4vh;\n    }\n\n    .amazing-influencers{\n        font-size: 6vw;\n        text-align: center;\n        margin-bottom: 0px;\n    }\n\n    .text-happy-explorers{\n        font-size: 6vw;\n        text-align: center;\n        margin-bottom: 0;\n        margin-top: 10vw;\n    }\n    \n    .empty-1{\n        width: 100%;\n        height: 4vw;\n    }\n\n\n    .travel-influencer-container{\n        width: 95vw;\n        height: auto;\n        margin: auto;\n        border-radius: 2vw;\n        overflow: hidden;\n        margin-bottom: 10vw;\n        margin-top: 8vw;\n        display: flex;\n    }\n\n    .travel-inf-img{\n        width: 100vw;\n        object-fit: contain;\n        border-radius: 2vw;\n    }\n\n    .travel-inf-text-1{\n        margin-left: 3vw;\n        margin-top: 6vw;\n        font-size: 4vw;\n        font-weight: bold;\n        position: absolute;\n    }\n\n    .travel-inf-text-2{\n        margin-left: 3vw;\n        margin-top: 11vw;\n        font-size: 2.8vw;\n        font-weight: normal;\n        position: absolute;\n    }\n\n    .travel-inf-btn{\n        position: absolute;\n        margin-left: 3vw;\n        margin-top: 20vw;\n        width: 20vw;\n        height: 6vw;\n        border-radius: 1vw;\n        background-color: #e65439;\n        color: white;\n        border: none;\n        font-size: 2.3vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component-container": `Home_entry-component-container__MTPQV`,
	"entry-component-image": `Home_entry-component-image__EJYxz`,
	"entry-component-title": `Home_entry-component-title__EfuAm`,
	"entry-component-title-heading": `Home_entry-component-title-heading__ADges`,
	"entry-component-title-description": `Home_entry-component-title-description__D4uIF`,
	"entry-component-search-box-container": `Home_entry-component-search-box-container__GBxBT`,
	"trip-filter": `Home_trip-filter__QgLb3`,
	"upcoming-explorations": `Home_upcoming-explorations__+7VZB`,
	"upcoming-explorations-subline": `Home_upcoming-explorations-subline__0cHvv`,
	"upcoming-text-m": `Home_upcoming-text-m__ehnuZ`,
	"underline": `Home_underline__Py5XA`,
	"filter-display-handler-1": `Home_filter-display-handler-1__P6J15`,
	"view-all-button": `Home_view-all-button__Y0kd1`,
	"book-exploration": `Home_book-exploration__kC3Lf`,
	"break": `Home_break__OnrHF`,
	"svg-container": `Home_svg-container__7+ZSq`,
	"svg": `Home_svg__JkjvG`,
	"svg-text": `Home_svg-text__-xCJ+`,
	"svg-subtext": `Home_svg-subtext__Q2L3K`,
	"amazing-influencers": `Home_amazing-influencers__DaOE5`,
	"text-happy-explorers": `Home_text-happy-explorers__fu9vJ`,
	"empty-1": `Home_empty-1__uYFyZ`,
	"travel-influencer-container": `Home_travel-influencer-container__qlevp`,
	"travel-inf-img": `Home_travel-inf-img__8rnt5`,
	"travel-inf-text-1": `Home_travel-inf-text-1__+RIFU`,
	"travel-inf-text-2": `Home_travel-inf-text-2__N5SB1`,
	"travel-inf-btn": `Home_travel-inf-btn__XcHYZ`,
	"upcoming-text-w": `Home_upcoming-text-w__6Q5i3`,
	"filter-display-handler": `Home_filter-display-handler__DBLBy`
};
export default ___CSS_LOADER_EXPORT___;
